import logo from './logo.svg';
import './App.css';
import store from './store';
import {Provider} from 'react-redux';
import Navheader from './Components/Navheader';
import Background from './Components/Background';
import Element from './Components/Element';
import styles from './Components/styles.module.scss';
import Button from './Components/Button';
import Card from './Components/Card';
import Footer from './Components/Footer';
import Vid from './Components/Vid';
import PasswordInput from './Components/PasswordInput';
import Modal from './Components/Modal';
import { useState } from 'react';
function FateItems(props) {
const [modal,setModal] = useState(null);
  const gameArray = props.games;
  const gameCardsArray = props.gameCards;
   const horrorGameArray = props.horrorGames;

  const images = [];
  for(let i = 1; i <= 82; i++){
    images.push("item_" + i + ".png");
  }
const desc = [
    'Increases Attack by 1.',
    'Increases Hit Rate by 1.',
    `Increases Luck by 1.`,
    `Increase HP by 1.`,
    `Gain 5 Birthday Presents. They clear all negative effects after use.`,
    `Gain 2 Revive Cakes. Revive cake ressurects you with 2 HP after dying.`,
    `Increase HP by 1. Using pizzas have 50% chance of restoring 2 HP instead of 1.`,
    `You move above obstacles, spikes, goo, etc..`,
    `Increase Speed by 1.`,
     'Active Item, Restores 1 HP for cost of 2 MP.',
     'Gives you 3 Bombs and Increases Bomb damage by 1.',
    'Increases Range by 1.', 
    `When you receive damage, there's 25% chance to negate it.`,
    'Active Item, Gives you 1-3 tokens for 1 MP.',
    'Increases Range by 1. Increases Luck by 1.',
    'Increases Hit Rate by 2. Each attack can make you bleed.',
    'Chose one Attribute out of 3 to increase.',
    'Increases Hit Rate by 1. Each key pickup restores 2HP',   
    'Increases Hit Rate by 1.',
    'Increases Hit Rate by 1. Increases Attack by 1. Decreases HP by 1.',
    `You're immune to fear.`,
    `Active Item, Increases Hit Rate by 1 for cost of 5 MP.`,
    `Active Item, Gives you empty HP container for cost of 8 MP.`,
    `Aftere getting to new Floor restore 1HP`,
    `Increase HP by 2. Increases Hit Rate by 1. Decreases Speed by 1.`,
    `Active Item, Clears you from all negative effects for cost of 1 MP.`,
    `Increases Luck by 1. Restore 2 HP.`,
    `Opening locked objects has 50% chance to save a key.`,
    `Poof Exclusive Item. Deals area damage around on interaction.`,

    `Capcake Exclusive Item. Shoots chunk in a straight line, can grow stronger, always turns to the player.`,
    `Sonia Exclusive Item. Follows and damages enemies.`,
    `Cubus Exclusive Item. After getting attacked by you rushes straight and deals
    area damage at the end.`,
    `Dream Room Item. After you eat 5 pizzas increase 1 random attribute by 1.`,
    `Dream Room Item. After taking damage, deal damage to all enemies in the room`,
    `Dream Room Item. Items in shops are 50% cheaper.`,
    `Dream Room Item. Damaging enemies makes them move away.`,
    `Dream Room Item. Increase Attack by 1, your attacks have chance to deal x2 damage.`,
    `Dream Room Item. Beds always spawn at least once on each floor.`,
    `Dream Room Item. Taking pickup items gives you double the amount.`,

    `Dream Room Item. Active Item. Shows location of Floor Pass for the cost of 1 MP.`,
    `Dream Room Item. If you manage to clear a room without taking damage, give you random items.`,
    `Dream Room Item. Hidden rooms in the walls are visible.`,
    `After picking up, choose 3 special passive abilities to have.`,
    `Appears in the starting room and Floor Pass location, teleports to random room after interaction.`,
    `Taking damage from projectles has a chance of restoring 1MP.`,
    `After each couple of seconds, deals damage to all enemies in a room.`,
    `Active Item. Teleport to a random unvisited location for the cost of 2 MP.`,
    `Your attacks have increased radius and damage.`,
    `Active Item. After use, open a portable shop where items are slightly more expensive.`,
 
    `Gain 3 chocolate bars. They give you immunity for couple of seconds.`,
    `Increase HP by 1. Gain 1 token for each pickup item left on the previous floor.`,
    `Increase HP by 1. Using pizzas has 50% to restore 1 MP.`,
    `Increases Hit Rate by 1. Your hit Rate is even higher if you stay still.`,
    `Gain 2 Tea Weeds. They increase Attack for couple of seconds.`,
    `You can deal area damage around your character at random.`,
    `After attacking, deal damage to random enemy.`,
    `Your bombs leave mayonaise after exploding which damages enemies on contact.`,
    `Gain 100 EXP after entering new floor.`,
    `Taking pickup items has a chance to give you 1 Cola. Using colas has 50% chance of restoring 1 more MP.`,
    
    `Increase Luck by 1. Increase Hit Rate by 1.`,
    `Increase Range by 1. Locations of Item Room and Shop are visible to you.`,
    `Increases Attack by 1. Your Attack is even higher if you stay still.`,
    `Active Item. You have a chance to gain 3 pizzas or poison yourself for the cost of 3 MP.`,
    `Your attacks have chance to Stop enemy for some time.`,
    `Increase Luck by 1. Tokens spent on shopping give you equal amount of EXP.`,
    `Your projectles have chance to move randomly.`,
    `Your bombs poison enemies.`,
    `Active Item. Gain random Skill Card for the cost of 5 MP.`,
    `First time taking damage in a room is negated.`,
    
    `Slaying enemies has a chance of restoring 1 MP.`,
    `Increase HP by 3. Decrease other Attributes by 1.`,
    `Bombs trigger twice.`,
    `Take 10% of Boss's Health at the start of battle.`,
    `You're immune to bomb damage. Gain 1 bomb at the start of each new floor.`,
    `Slaying enemies has chance to activate 4-directional wave of attacks that damages everything it reaches.`,
    `Active Item. Restore 2 HP for the cost of 3 MP.`,
    `Increases ALL Attributes by 1.`,
    `Appears at the left of the map and shots 3 projectles straight.`,
    `After you complete floor in 5 minutes or less gain random items.`,
    
    `Active Item. Gives you 1 MP for the cost of EXP, cost increases each use.`,
    `Summons copy of your character that damages enemy on contact and returns after some time. Moves the same as you.`,
    `Active Item. Increase random attribute by 1 for the cost of 5 MP.`
    


  ];


let itemsArray = [];
let itemsDescArray = [];
const openModal = (e) => {
  console.log(e.target.textContent);
  let x = parseInt(e.target.textContent) - 1;
  console.log(x);
  setModal(itemsDescArray[x]);
  
}
const closeModal = () => {
  setModal(null);
}
images.forEach((e,i)=>{
  itemsArray.push(<div onClick={openModal} className={`${styles.fateItem} ${styles['fateItem--normal']}`}><div className={`${styles.fm}`} style={{background: `url("/pictures/items/${images[i]}") center/cover no-repeat`}}><a style={{opacity: 0, position: 'absolute'}}>{i + 1}</a></div></div>)
});

images.forEach((e,i)=>{
  itemsDescArray.push(<div className={`${styles.fateItem} ${styles['fateItem--desc']}`}>
    <div className={`${styles.fateItemDesc}`}>{desc[i]}</div>
    <div className={`${styles.fm}`} style={{background: `url("/pictures/items/${images[i]}") center/cover no-repeat`}}></div>
    
    </div>)
});
  return (

    <div className="App"
    style={{
      width: '100%',
      background:'black',
      overflowX: "hidden"
    }}>
    <Background halloween={props.halloween} xmas={props.xmas}></Background>
    <Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element><br/>
        <div className={`${styles[`h2`]}`}>Poof's Killergarten Divided Fate Items</div>
        <br/>
        {modal != null && <Modal halloween={props.halloween} xmas={props.xmas} click={closeModal}>{modal}</Modal>}
       <div className={`${styles.fateItemList}`}>
             {itemsArray}
                  <Footer halloween={props.halloween} xmas={props.xmas}></Footer>
       </div>
    <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
    <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
        <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                   <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
    <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
        <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                                <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                                             <Element halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                                  <Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={1}></Element>


        

    <Navheader halloween={props.halloween} xmas={props.xmas} games={gameArray} horrorGames={horrorGameArray}></Navheader>
   
    </div>

    
  );
}

export default FateItems;
